import { c as _c } from "react/compiler-runtime";
import type { ColumnFiltersState } from '@tanstack/react-table';
import { useCallback } from 'react';
interface FilterMapping {
  [filterKey: string]: string;
}
interface UseTableFiltersHandlerConfig {
  setColumnFilters: (filters: ColumnFiltersState) => void;
  filterMapping: FilterMapping;
}
export const useTableFiltersHandler = t0 => {
  const $ = _c(5);
  const {
    setColumnFilters,
    filterMapping
  } = t0;
  let t1;
  if ($[0] !== filterMapping || $[1] !== setColumnFilters) {
    t1 = newFilters => {
      const newColumnFilters = [];
      Object.entries(newFilters).forEach(t2 => {
        const [filterKey, filterValue] = t2;
        const columnId = filterMapping[filterKey];
        if (!columnId) {
          return;
        }
        if (Array.isArray(filterValue) && filterValue.length > 0 || typeof filterValue === "string" || typeof filterValue === "boolean") {
          newColumnFilters.push({
            id: columnId,
            value: filterValue
          });
        }
      });
      setColumnFilters(newColumnFilters);
    };
    $[0] = filterMapping;
    $[1] = setColumnFilters;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleFiltersChange = t1;
  let t2;
  if ($[3] !== handleFiltersChange) {
    t2 = {
      handleFiltersChange
    };
    $[3] = handleFiltersChange;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};